import { render, staticRenderFns } from "./CMAttachmentsDevisForm.vue?vue&type=template&id=f1731eca&"
import script from "./CMAttachmentsDevisForm.vue?vue&type=script&lang=js&"
export * from "./CMAttachmentsDevisForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1731eca')) {
      api.createRecord('f1731eca', component.options)
    } else {
      api.reload('f1731eca', component.options)
    }
    module.hot.accept("./CMAttachmentsDevisForm.vue?vue&type=template&id=f1731eca&", function () {
      api.rerender('f1731eca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/attachments/CMAttachmentsDevisForm.vue"
export default component.exports